import { Breadcrumb } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { MultiFetcher } from './utilities/MultiFetcher';
import * as _ from 'lodash';
import { PageLoader } from './utilities/PageLoader';
import { Job } from '../models/Job';
import i18n from '../i18n';
import { JobItem } from './utilities/JobItem';
// import { useParams } from 'react-router-dom';

interface State {
    jobs: Job[];
}

export const Jobs = () => { 
    const { t } = useTranslation();
    // let { lng } = useParams();

    const [state, setState] = useState<State>({
        jobs: []
      });

    const {fetchMultiple: fetchJobs, isLoading} = MultiFetcher('job');   

    const fetchData = useCallback(async () => {
        const jobs = await fetchJobs({});
        setState(prevState => ({ ...prevState, jobs }));
        //console.log(`data: ${JSON.stringify(newsItems)}`); 
    }, [fetchJobs]);

    useEffect(() => {
        window.scrollTo(0, 0)

        fetchData();
    }, [fetchData])

    return (
        <React.Fragment>
            <Helmet>
                <title>InnoTrans | {t('common:jobs')}</title>
                <meta name="description" content={t('pageDescriptions:jobs')} />
                <meta name="keywords" content={t('pageKeywords:jobs')} />
                <meta httpEquiv="content-language" content={i18n.language?.substr(0,2)} />
                {/* <link rel="canonical" href={`https://innotrans.nl${lng ? `/${lng}` : ''}/news`} /> */}
            </Helmet>

            <Breadcrumb style={{ margin: '16px 0', paddingLeft: '50px' }}>
                <Breadcrumb.Item><h1>{t('common:jobs')}</h1></Breadcrumb.Item>
            </Breadcrumb>

            <PageLoader loading={isLoading} subTitle={'Loading data...'}>
                <div className="bg-lightgray" style={{ minHeight: 'calc(100vh - 170px)'}}>
                    <div className="content-flex">
                        {_.map(state.jobs, (job, index) => {
                            return <JobItem key={index} job={job} />
                        })}
                    </div>
                </div>
            </PageLoader>

        </React.Fragment>
    );
}
